import { useState } from "react";
import { Tooltip } from "react-tooltip";

import WoSectionCard from "../common/WoSectionCard";
import Timesheet from "./Timesheet";
import { formatMinutes } from "./TimesheetTable";

// Timesheet section as an independent card matching the proposals/forms look.
// The header carries the WO-wide labor total ("Timesheet • | Total Labor
// Hours: X (i)"); the dot flags that time has been logged.
function WoTimesheet({ order }) {
  const [totalLaborMinutes, setTotalLaborMinutes] = useState(0);

  return (
    <WoSectionCard
      title="Timesheet"
      flush
      headerExtra={
        <span className="flex items-center gap-4 min-w-0">
          {totalLaborMinutes > 0 && (
            <span className="w-2 h-2 rounded-full bg-[#0065FC]" />
          )}
          <span className="w-px h-4 bg-[#E5E8F3]" />
          <span className="flex items-center gap-2 min-w-0">
            <span className="font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] text-[#6A7282]">
              Total Labor Hours:
            </span>
            <span className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-[#1A2332]">
              {formatMinutes(totalLaborMinutes)}
            </span>
            <img
              src="/images/common/tooltip.png"
              alt="info"
              data-tooltip-id="timesheet-total-tooltip"
              data-tooltip-html="Sum of all regular, travel, and overtime hours logged on this work order."
              className="w-3 h-3"
              onClick={(e) => e.stopPropagation()}
            />
            <Tooltip id="timesheet-total-tooltip" positionStrategy="fixed" />
          </span>
        </span>
      }
    >
      <Timesheet order={order} onTotalMinutes={setTotalLaborMinutes} />
    </WoSectionCard>
  );
}

export default WoTimesheet;
